import React from "react"

const FirebaseContext = React.createContext({})

export default FirebaseContext
